// learn more about configuring shapes: https://mui.com/material-ui/customization/shape/
export const shape = {
  borderRadius: 8,
  cornerSm: 8,
  cornerLg: 16,
};
